import { FC } from "react";
import { InputText } from "@goodfill/ui-components";
import { RegulatoryField } from "./RegulatoryField";

export type RegulatoryQuestionFieldProps = {
  answer: boolean;
  companyStockSymbols: string[];
};

export const RegulatoryQuestionField: FC<RegulatoryQuestionFieldProps> = ({
  answer,
  companyStockSymbols,
}: RegulatoryQuestionFieldProps) => {
  return (
    <div className="flex flex-col px-1 md:px-2">
      <RegulatoryField label="Control of Publicly Traded Company">
        <InputText neutral={true} value={answer ? "Yes" : "No"} disabled={false} />
      </RegulatoryField>
      <RegulatoryField label="Companies">
        <InputText neutral={true} value={companyStockSymbols.join(", ")} disabled={false} />
      </RegulatoryField>
    </div>
  );
};
